export const uk = {
    access: 'Права доступа',
    cancel: 'Отмена',
    save: 'Сохранить'
};
